import './style.css';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';

interface ICronometerInput {
  setData: (time: string) => void;
  data: string;
  disabled: boolean;
}

export default function CronometerInput({
  setData,
  data,
  disabled
}: ICronometerInput) {
  return (
    <div
      id='cronometer'
      className='flex flex-row items-center rounded-sm bg-[#fff] px-2 py-2 border-hairline border-color-darkest'
    >
      <TimePicker 
        onChange={(value) => setData(value ?? "")} 
        value={data} 
        clockIcon={null} 
        format='HH:mm' 
        locale='pt-BR'
        disableClock
        className="border-none"
        disabled={disabled}
      />
    </div>
  );
}
